module.exports = __webpack_public_path__ + "static/media/background.8f1ee49c.gif";